export const RuI18n = {
  Create: 'Ð¡Ð¾Ð·Ð´Ð°ÑÑ',
  'Select content type': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ð¼Ð¾Ð³Ð¾',
  Select: 'ÐÑÐ±ÑÐ°ÑÑ',
  'Content types': 'Ð¢Ð¸Ð¿Ñ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ð¼Ð¾Ð³Ð¾',
  'Select group': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ',
  'Delete permission': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ðµ',
  'Do you really want to delete permission "{{title}}" from group?':
    'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ðµ "{{title}}" Ñ Ð³ÑÑÐ¿Ð¿Ñ?',
  'Select permissions for append to group': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ñ Ð´Ð»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð² Ð³ÑÑÐ¿Ð¿Ñ',
  Groups: 'ÐÑÑÐ¿Ð¿Ñ',
  'Select permission': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ðµ',
  Permissions: 'Ð Ð°Ð·ÑÐµÑÐµÐ½Ð¸Ñ',
  'Delete group': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð³ÑÑÐ¿Ð¿Ñ',
  'Do you really want to delete group "{{title}}" from user?':
    'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ Ð³ÑÑÐ¿Ð¿Ñ "{{title}}" Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ?',
  'Select groups for append to user': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ Ð´Ð»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ',
  'Select user': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ',
  Users: 'ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ð¸',
  Info: 'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ',
  OK: 'ÐÐº',
  Error: 'ÐÑÐ¸Ð±ÐºÐ°',
  'Error Log': 'ÐÑÐ¸Ð±ÐºÐ°',
  Russian: 'Ð ÑÑÑÐºÐ¸Ð¹',
  English: 'ÐÐ½Ð³Ð»Ð¸Ð¹ÑÐºÐ¸Ð¹',
  Close: 'ÐÐ°ÐºÑÑÑÑ',
  Append: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ',
  'No data': 'ÐÐµÑ Ð´Ð°Ð½Ð½ÑÑ',
  'Loading...': 'ÐÐ°Ð³ÑÑÐ·ÐºÐ°...',
  Action: 'ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ',
  Language: 'Ð¯Ð·ÑÐº',
  'Sign out': 'ÐÑÐ¹ÑÐ¸',
  'Sign in': 'ÐÐ¾Ð¹ÑÐ¸',
  'Split button!': 'Ð Ð°Ð·Ð´ÐµÐ»Ð¸ÑÐµÐ»Ñ',
  Authorization: 'ÐÐ²ÑÐ¾ÑÐ¸Ð·Ð°ÑÐ¸Ñ',
  'Sign up': 'ÐÐ°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑÑÑ',
  Registration: 'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ',
  Yes: 'ÐÐ°',
  'Do you really want to leave?': 'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð²ÑÐ¹ÑÐ¸?',
  'Your session has expired, please re-login':
    'ÐÐ°ÑÐ° ÑÐµÑÑÐ¸Ñ Ð¸ÑÑÐµÐºÐ»Ð°. ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð°Ð²ÑÐ¾ÑÐ¸Ð·ÑÐ¹ÑÐµÑÑ ÑÐ½Ð¾Ð²Ð°, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ ÑÐ°Ð±Ð¾ÑÑ',
  No: 'ÐÐµÑ',
  Email: 'Ð­Ð». Ð¿Ð¾ÑÑÐ°',
  Password: 'ÐÐ°ÑÐ¾Ð»Ñ',
  'Confirm password': 'ÐÐ°ÑÐ¾Ð»Ñ ÐµÑÐµ ÑÐ°Ð·',
  Cancel: 'ÐÑÐ¼ÐµÐ½Ð°',
  'Item #{{id}}': 'ÐÐ°Ð¿Ð¸ÑÑ #{{id}}',
  'Create new item': 'Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð½Ð¾Ð²ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ',
  'Update item #{{id}}': 'ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ #{{id}}',
  Save: 'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ',
  'Delete item #{{id}}': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ #{{id}}',
  'Do you really want to delete item?': 'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÑ Ð·Ð°Ð¿Ð¸ÑÑ?',
  Delete: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ',
  'Select item': 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð·Ð°Ð¿Ð¸ÑÑ',
  Menu: 'ÐÐµÐ½Ñ'
};
